import type { IStaff } from './staff';
import { staffSchema } from './staff';
import { Joi, objectSchemaOf, actionCreator } from '../helpers';
import { ORGANISATIONS_OUTPUT } from './topics';

export const NEW_STAFF = 'ORGANISATIONS/NEW_STAFF' as const;

export interface INewStaffAction {
  type: typeof NEW_STAFF;
  payload: IStaff;
}

export const newStaffActionSchema = objectSchemaOf<INewStaffAction>({
  type: Joi.string().valid(NEW_STAFF).required(),
  payload: staffSchema.required(),
});

export const newStaff = actionCreator({
  type: NEW_STAFF,
  schema: newStaffActionSchema,
  topic: ORGANISATIONS_OUTPUT,
});
